import { render, staticRenderFns } from "./IconClip.vue?vue&type=template&id=32668922"
import script from "./IconClip.vue?vue&type=script&lang=ts"
export * from "./IconClip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports